import { Component, OnInit, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-pdf-viewer-dialog',
  templateUrl: './pdf-viewer-dialog.component.html',
  styleUrls: ['./pdf-viewer-dialog.component.scss']
})
export class PdfViewerDialogComponent implements OnInit, AfterViewInit {
  @ViewChild('pdfContainer') pdfContainer?: ElementRef;
  
  pdfUrl: string = '';
  title: string = '';
  loadError: string = '';
  loadingMessage: string = '';
  currentLanguage: string = 'he';
  httpHeaders: any;

  constructor(
    public config: DynamicDialogConfig,
    public ref: DynamicDialogRef
  ) {}

  ngOnInit(): void {
    this.pdfUrl = this.config.data?.url || '';
    this.title = this.config.data?.title || '';
    this.currentLanguage = this.config.data?.currentLanguage || 'he';
    this.loadingMessage = 'Loading PDF document: ' + this.title;
    console.log('PDF Viewer initialized with URL:', this.pdfUrl);
    console.log('PDF Viewer language:', this.currentLanguage);
    console.log('URL contains .pdf:', this.pdfUrl.toLowerCase().includes('.pdf'));
    console.log('URL file extension:', this.pdfUrl.split('.').pop());
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.pdfContainer?.nativeElement?.focus();
    }, 100);
  }

  onPdfLoaded(): void {
    console.log('PDF loaded successfully');
    this.loadingMessage = 'PDF document loaded successfully. Use arrow keys to navigate pages.';
  }

  onPdfLoadingFailed(error: any): void {
    console.error('PDF loading failed:', error);
    this.loadError = 'Failed to load PDF. Please try downloading it instead.';
    this.loadingMessage = 'Error: Failed to load PDF document.';
  }

  close(): void {
    this.ref.close();
  }
}
